(function(angular){
	'use strict';
	
	angular
		.module('reitElementListingModule', [
			'BaseConfig',
			'bigModule',
			'eventsModule',
			'iconModule',
			'imageLazyModule',
			'mapboxGLModule',
			'popoverModule',
			'SharedFilters'
		]);

})(window.angular);